module.exports = __webpack_public_path__ + "static/img/addNurse.914669a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/addNurse.png
// module id = mf5I
// module chunks = 1